/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateWhatsAppMarkAsReadPathParams,
	CandidateWhatsAppMarkAsReadRequest,
	CandidateWhatsAppMarkAsReadResponse,
} from '../types/CandidateWhatsAppMarkAsRead'

/**
 * POST /candidates/:candidateId/whatsapp/read
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::markAsRead
 */
export async function candidateWhatsAppMarkAsRead(
	candidateId: CandidateWhatsAppMarkAsReadPathParams['candidateId'],
	data: CandidateWhatsAppMarkAsReadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateWhatsAppMarkAsReadResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/whatsapp/read`, data, config)
}
